module.exports = __webpack_public_path__ + "static/media/declaim@2x.ff2ffc51.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_31/imgs/declaim@2x.png
// module id = 87
// module chunks = 0